import { ITestModeration, IAction } from "../models";
import {
    GET_MODERATION_PROCESS,
    EVALUATE_TEST_REQUEST,
    EVALUATE_TEST,
    FINISH_MODERATION,
    FINISH_MODERATION_REQUEST,
    GO_BACK,
    GO_BACK_REQUEST,
} from "../types";

const initialState: ITestModeration = {
    isFetching: false,
    moderation: null,
}

export default (
    testModeration = initialState,
    action: IAction,
): ITestModeration => {
    switch (action.type) {
        case GET_MODERATION_PROCESS:
            return {
                moderation: action.payload,
                isFetching: false,
            };
        case EVALUATE_TEST_REQUEST:
        case GO_BACK_REQUEST:
            return {
                ...testModeration,
                isFetching: true,
            };
        case EVALUATE_TEST:
            return {
                isFetching: false,
                moderation: {
                    ...testModeration.moderation!,
                    values: [...testModeration.moderation!.values, action.payload!.value],
                    comments: [...testModeration.moderation!.comments, action.payload!.comment],
                },
            };
        case GO_BACK: 
            return {
                isFetching: false,
                moderation: {
                    ...testModeration.moderation!,
                    values: testModeration.moderation!.values.filter((v, i) => i !== testModeration.moderation!.values.length -1),
                    comments: testModeration.moderation!.comments.filter((v, i) => i !== testModeration.moderation!.comments.length -1),
                },
            };
        case FINISH_MODERATION_REQUEST:
            return {
                ...testModeration,
                isFetching: true,
            };
        case FINISH_MODERATION:
            return {
                ...testModeration,
                moderation: {
                    ...testModeration.moderation!,
                    finished: true,
                },
            };

        default:
            return testModeration;
    }
};
